export function normalizePackageOrdering(
  ordering: string | undefined,
  packageImprovements: boolean
): string | undefined {
  if (!ordering || !packageImprovements) {
    return ordering;
  }

  return ordering.replace(/^(-?)created$/, "$1modified");
}

export function queryParamsToApiParams(params: Record<string, string>) {
  return {
    page: params.page,
    page_size: params.page_size,
    ordering: params.ordering,
    created_by: params.created_by && params.created_by.split(","),
    customer_group_id:
      params.customer_group_id && params.customer_group_id.split(","),
    customer_groups:
      params.customer_groups && params.customer_groups.split(","),
    search: params.search,
    is_active: params.is_active && params.is_active === "true",
    tags: params.tags && params.tags.split(","),
    permissible_purpose:
      params.permissible_purpose && params.permissible_purpose.split(","),
  };
}
